// policy routes
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import PolicyDetails from './PolicyDetails.vue';
import { RouteNames } from '@/router/routeNames';
import MyPolicyTab from './PolicyMyPolicy/MyPolicyTab.vue';
import GuidanceCalculatorTab from './PolicyGuidanceCalculator/GuidanceCalculatorTab.vue';
import PolicyBenefitsTab from './PolicyLearnMore/PolicyBenefitsTab.vue';

export default {
  path: '/policy',
  component: DashboardLayout,
  children: [
    {
      path: '',
      component: PolicyDetails,
      children: [
        {
          name: RouteNames.POLICY_DETAILS,
          alias: 'details/:contractId/paynow',
          path: 'details/:contractId',
          component: MyPolicyTab,
          meta: {
            pageTitle: 'Policy.Details',
            indexOfRoute: 0,
          },
        },
        {
          name: RouteNames.GUIDANCE_CALCULATOR,
          path: 'guidance',
          component: GuidanceCalculatorTab,
          params: {
            page: 'guidance',
          },
          meta: {
            pageTitle: 'Guidance.Calculator',
            indexOfRoute: 1,
          },
        },
        {
          name: RouteNames.TERM_LIFE_BENEFITS,
          path: 'benefits',
          component: PolicyBenefitsTab,
          params: {
            page: 'benefits',
          },
          meta: {
            pageTitle: 'Term.Life.Benefits',
            indexOfRoute: 2,
          },
        },
      ],
    },
  ],
};
